import { DateTime } from 'luxon';

export default () => {
  const years = [];
  const startDate = DateTime.now();
  const startYear = startDate.plus({ months: 4 }).year;
  const endYear = startDate.plus({ years: 3 }).year;
  const transferYear = `TR${startDate.plus({ months: 4 }).toFormat('yy')}`; // generate TR + last 2 digits of startYear;

  for (let i = startYear; i < startYear + 4; i++) {
    years.push(`${i}`);
  }

  years.push(transferYear, 'All');

  return { startYear, endYear, years };
};



// WEBPACK FOOTER //
// ./src/utilities/generateYears.js